export const languageOptions = {
    english: "English",
    arabic: "Arabic",
    dutch: "Dutch",
    french: "French",
    german: "German",
    hindi: "Hindi",
    multi_en_hi: "Hindi/En",
    italian: "Italian",
    japanese: "Japanese",
    portuguese: "Portuguese",
    spanish: "Spanish",
    multi_ar_en_hi: "Multi Lingual (EN/AR/HI/UR)",
    aws_multi_en_gu: "Multi Lingual (English/Gujrati)",
    aws_gujarati: "Gujrati"
};

export const LIMIT = 10